import useSyncRecentTradesWithDataApiServer from './useSyncRecentTradesWithDataApiServer';
import useSyncRecentTradesWithDlobServerWebsocket from './useSyncRecentTradesWithDlobServerWebsocket';

/**
 * SEE ui/src/hooks/driftEvents/README.md for explanation of how these hooks link with rest of event syncing
 */

const useDriftGlobalEventSubscribers = () => {
	useSyncRecentTradesWithDlobServerWebsocket();
	useSyncRecentTradesWithDataApiServer();
};

export default useDriftGlobalEventSubscribers;
